import { render, staticRenderFns } from "./LeftPanel.vue?vue&type=template&id=23831424&"
import script from "./LeftPanel.vue?vue&type=script&lang=ts&"
export * from "./LeftPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports